import React, { FC, Component } from 'react';
import { connect } from 'react-redux';

import { translations } from 'i18n';
import { fetchHasGalleryGrant } from 'actions/registry';
import { setDeeplinkStatus } from 'actions/gallery';

import { PremiumUpsellDeeplink } from '../Deeplink';
import ButtonBar from '../Button/ButtonBar';

import add_icon from '../../../icons/ic_add.svg';

export enum PremiumSubscribeButtonType {
  INSTALL_BUTTON,
  TEXT
}

type ReduxProps = ReturnType<typeof mapDispatchToProps>;

interface PremiumSubscribeButtonProps extends ReduxProps {
  trigger: string;
  type: PremiumSubscribeButtonType;
}

class PremiumSubscribeButton extends Component<PremiumSubscribeButtonProps> {
  visibilityChangeHandler = () => {
    if (document.visibilityState === 'visible') {
      document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
      this.props.fetchHasGalleryGrant();
      this.props.setDeeplinkStatus(false);
    }
  }

  onClick = () => {
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    this.props.setDeeplinkStatus(true);
  }

  render() {
    const { trigger, type } = this.props;
    let ButtonComponent: React.FC<ButtonProps>;

    if (type === PremiumSubscribeButtonType.INSTALL_BUTTON) {
      ButtonComponent = InstallButton;
    } else {
      ButtonComponent = TextButton;
    }

    return (
      <PremiumUpsellDeeplink
        triggerFeature="gallery"
        triggerView={trigger}
      >
        <ButtonComponent onClick={this.onClick} />
      </PremiumUpsellDeeplink>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  fetchHasGalleryGrant: () => dispatch(fetchHasGalleryGrant()),
  setDeeplinkStatus: (isOpen: boolean) => dispatch(setDeeplinkStatus(isOpen))
});

interface ButtonProps {
  onClick: (() => void);
}

const InstallButton: FC<ButtonProps> = ({ onClick }) => (
  <ButtonBar
    id="premium-subscribe-button"
    variant="filled"
    icon={add_icon}
    onClick={onClick}
  >
    {translations.premium.subscribeToPremium()}
  </ButtonBar>
);

const TextButton: FC<ButtonProps> = ({ onClick }) => (
  <ButtonBar
    id="premium-subscribe-button"
    aria-label="premium-subscribe-button"
    variant="text"
    onClick={onClick}
  >
    {translations.premium.subscribeToPremium()}
  </ButtonBar>
);

export default connect(null, mapDispatchToProps)(PremiumSubscribeButton);
